import { FC } from "react";
import { Author, singleNewsOverviewTypes } from "../../types/NewsTypes";
import { SingleNewsActions } from "./SingleNewsActions";
import { SingleNewsFeed } from "./SingleNewsFeed";
import ReactMarkdown from "react-markdown";
import { SingleNewsMeta } from "./SingleNewsMeta";
import { CoverImage } from "@/components";
import { Box, Flex, Grid, Separator } from "@radix-ui/themes";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import useDocumentTitle from "@/hooks/useDocumentTitle";

type Props = {
  data: singleNewsOverviewTypes & {
    author: Author;
  };
};
export const SingleNewsUI: FC<Props> = ({ data }): JSX.Element => {
  useDocumentTitle(data.title);

  return (
    <>
      <CoverImage
        src={data.imageURL}
        alt={data.title}
        heading={data.title}
        desc={data.intro}
      />

      <Box>
        <Separator orientation="horizontal" style={{ width: "100%" }} />
      </Box>

      <Grid columns="12" gap={{ initial: "0", lg: "9" }}>
        <Box
          gridColumnStart={{ initial: "1", lg: "1" }}
          gridColumnEnd={{ initial: "13", lg: "10" }}
        >
          <ReactMarkdown>{data.content}</ReactMarkdown>
        </Box>
        <Box gridColumnStart={{ initial: "1", lg: "10" }} gridColumnEnd="13">
          <Flex direction="column" gap="3" py="5">
            <SingleNewsMeta data={data} />
            <SingleNewsActions data={data} />
          </Flex>
        </Box>
      </Grid>

      {/* Topic Discussion */}
      {brand.hasFeature.posts && (
        <Box>
          <SingleNewsFeed />
        </Box>
      )}
    </>
  );
};
